module.exports = __webpack_public_path__ + "img/DataEase-white_bak.5517dfeb.png";